import React from 'react';
import { BarChart, Bar, XAxis, ResponsiveContainer, Tooltip, YAxis, Legend } from 'recharts';
import PropTypes from 'prop-types';
import { Box, Grid, Stack, Typography } from '@mui/material';
import Bullet from 'shared/components/Bullet';

const MixBarChart = ({ data, dataKey = [] }) => {
    return (
        <ResponsiveContainer width='100%' height={400}>
            <BarChart
                barSize={15}
                data={data}
                margin={{
                    top: 20,
                    right: 0,
                    left: 0,
                    bottom: 5,
                }}
            >
                <XAxis dataKey='name' dy={10} />
                <YAxis />
                <Legend
                    wrapperStyle={{
                        paddingTop: '20px',
                    }}
                />
                <Tooltip content={<CustomTooltip />} />
                {
                    dataKey.map((item, index) => (
                        <Bar key={index} dataKey={item.name} name={item.name} stackId={item.stackId} fill={item.color} radius={[10, 10, 0, 0]} />
                    ))
                }
            </BarChart>
        </ResponsiveContainer>
    );
};

export default MixBarChart;

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <Stack bgcolor={'rgba(255,255,255,0.9)'} padding={4} borderRadius={2} boxShadow={'0 4px 10px 0 rgba(0,0,0,.25)'} borderColor={'transparent !important'}>
                <Typography variant='h4' fontWeight={'bold'}>[{label}] {payload[0].payload.actualName}</Typography>
                <Grid container rowSpacing={2} columnSpacing={4} sx={{ marginTop: 2, width: '350px' }}>
                    {
                        payload && payload.map((item, index) => (
                            <>
                                <Grid item xs={9} key={index}>
                                    <Stack direction={'row'} alignItems={'flex-start'} spacing={3}>
                                        <Box sx={{ mt: 1 }}>
                                            <Bullet bgColor={item.color} />
                                        </Box>
                                        <Typography>{item.name}</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography>{item.value}</Typography>
                                </Grid>
                            </>
                        ))
                    }
                </Grid>
            </Stack>
        );
    }

    return null;
};

CustomTooltip.propTypes = {
    active: PropTypes.any,
    payload: PropTypes.any,
    label: PropTypes.any,
}
MixBarChart.defaultProps = {
    data: [],
    dataKey: []
};

MixBarChart.propTypes = {
    data: PropTypes.array,
    dataKey: PropTypes.array
};
